var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"coupon-layout"}},[_c('div',{attrs:{"id":"fixTop"}},[_c('TopHead'),_c('TabMain')],1),_c('div',{staticClass:"coupon-layout-content",style:({ paddingTop: _vm.fixTop + 'px' }),attrs:{"id":"coupon-layout-content"}},[(_vm.showNav)?_c('NavTab'):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }